import { all, takeEvery, put, call } from 'redux-saga/effects';
import actions from './actions';
import { addData } from '../../helpers/fackBackend_Helper';

function* createBulkAdditionalServiceResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/createBulkAdditionalServices', data);
        if (response.Status) {
            yield put(actions.createBulkAdditionalServiceSuccess(response.Message));
        } else {
            yield put(actions.createBulkAdditionalServiceFailed(response.Message));
        }
    } catch (error) {
        yield put(actions.createBulkAdditionalServiceFailed(error.Message));
    }
}

function* getAdditionalServiceResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, '/getAllAdditionalServiceRequest', data);
        if (response.Status) {
            yield put(actions.getAdditionalServiceSuccess(response.Message, response.Data));
        } else {
            yield put(actions.getAdditionalServiceFailed(response.Message));
        }
    } catch (error) {
        yield put(actions.getAdditionalServiceFailed(error.Message));
    }
}

export default function* rootSaga() {
    yield all([takeEvery(actions.CREATE_BULK_ADDITIONAL_SERVICE, createBulkAdditionalServiceResponse)]);
    yield all([takeEvery(actions.GET_ADDITIONAL_SERVICE, getAdditionalServiceResponse)]);
}